import CustomButton from "Components/Custom/CustomButton";
import { GlobalImage } from "config/image";

const BrandColorModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  if (!isOpen) return null;

  return (
    <div className="brand-modal-overlay">
      <div className="brand-modal">
        <div className="brand-modal-header">
          <h2 className="brand-modal-title">Brand Colour</h2>
          <button className="brand-modal-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <p className="brand-modal-description">
          Your brand color will be used to personalise your quotes, invoices,
          and templates, helping maintain a consistent and professional look
          across your business materials.
        </p>

        <h5 className="brand-modal-preview-title">Preview</h5>

        <div className="brand-modal-img">
          <img
            src={GlobalImage.businessProfile}
            width={"100%"}
            height={"100%"}
            alt="BusinessProfile"
          />
        </div>
        <CustomButton
          type="button"
          text="Got It!"
          onClick={onClose}
          className="brand-modal-btn"
        />
      </div>
    </div>
  );
};

export default BrandColorModal;
